var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("list-loading " + (_vm.loading ? 'onloading' : '')),attrs:{"dcolor":""}},[(_vm.loading)?_c('iconic',{attrs:{"name":"gspinner"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }